"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardLayoutSection = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var flatMap_1 = tslib_1.__importDefault(require("lodash/flatMap"));
var DashboardLayoutItem_1 = require("./DashboardLayoutItem");
var DashboardLayoutSectionRenderer_1 = require("./DashboardLayoutSectionRenderer");
var DashboardLayoutSectionHeaderRenderer_1 = require("./DashboardLayoutSectionHeaderRenderer");
function DashboardLayoutSection(props) {
    var section = props.section, _a = props.sectionRenderer, sectionRenderer = _a === void 0 ? DashboardLayoutSectionRenderer_1.DashboardLayoutSectionRenderer : _a, _b = props.sectionHeaderRenderer, sectionHeaderRenderer = _b === void 0 ? DashboardLayoutSectionHeaderRenderer_1.DashboardLayoutSectionHeaderRenderer : _b, _c = props.itemKeyGetter, itemKeyGetter = _c === void 0 ? function (_a) {
        var item = _a.item;
        return item.index();
    } : _c, _d = props.gridRowRenderer, gridRowRenderer = _d === void 0 ? function (_a) {
        var children = _a.children;
        return children;
    } : _d, itemRenderer = props.itemRenderer, widgetRenderer = props.widgetRenderer, screen = props.screen;
    var renderProps = { section: section, screen: screen };
    var items = flatMap_1.default(section.items().asGridRows(screen), function (itemsInRow) {
        var rowItems = itemsInRow.map(function (item) { return (react_1.default.createElement(DashboardLayoutItem_1.DashboardLayoutItem, { key: itemKeyGetter({ item: item, screen: screen }), item: item, itemRenderer: itemRenderer, widgetRenderer: widgetRenderer, screen: screen })); });
        return gridRowRenderer
            ? gridRowRenderer({ children: rowItems, screen: screen, section: section, items: itemsInRow })
            : rowItems;
    });
    return sectionRenderer(tslib_1.__assign(tslib_1.__assign({}, renderProps), { DefaultSectionRenderer: DashboardLayoutSectionRenderer_1.DashboardLayoutSectionRenderer, children: (react_1.default.createElement(react_1.default.Fragment, null,
            sectionHeaderRenderer &&
                sectionHeaderRenderer({
                    section: section,
                    screen: screen,
                    DefaultSectionHeaderRenderer: DashboardLayoutSectionHeaderRenderer_1.DashboardLayoutSectionHeaderRenderer,
                }),
            items)) }));
}
exports.DashboardLayoutSection = DashboardLayoutSection;
//# sourceMappingURL=DashboardLayoutSection.js.map